<template>
  <div class="myweb">
    <headBox title="我的网店"></headBox>
    <div class="content">
      <div class="item" @click="goxcx()">
        <div class="item-content">
          <div class="icon green">
            <i class="icon-xiaochengxu"></i>
          </div>
          <div class="title">小程序</div>
          <div class="info-box">
            <div class="text1">使用场景：微信文章内容/微信公众号自定义菜单</div>
            <div class="text2">可编辑保险产品，自定义管理小程序店铺，支持添加测评文章等</div>
          </div>
        </div>
        <el-button class="org-btn">选择</el-button>
      </div>

      <div class="item" @click="gomyphone()">
        <div class="item-content">
          <div class="icon blue">
            <i class="icon-h5duan"></i>
          </div>
          <div class="title">H5端</div>
          <div class="info-box">
            <div class="text1">使用场景：微信公众号/H5（支持自定义模板）</div>
            <div class="text2">可编辑保险产品，支持添加测评文章等，适用于各类平台场景</div>
          </div>
        </div>
        <el-button class="org-btn">选择</el-button>
      </div>

      <div class="item" @click="goset()">
        <div class="item-content">
          <div class="icon purple">
            <i class="icon-diannaoduan"></i>
          </div>
          <div class="title">电脑端</div>
          <div class="info-box">
            <div class="text1">使用场景：PC网站 </div>
            <div class="text2">仅限于PC网站显示，不可自定义模板</div>
          </div>
        </div>
        <el-button class="org-btn">选择</el-button>
      </div>
    </div>
  </div>
</template>

<script>
//当前实例组件
import headBox from '@/components/head.vue'
export default {
  data: () => ({
    flexiableH: 404,
  }),
  components: { headBox },
  created() {},
  methods: {
    goset() {
      this.$router.push('/webset')
    },
    gomyphone() {
      //websiteType 	网站类型(1pc端 2手机端 3小程序)
      this.$router.push({ path: '/myphone', query: { websiteType: 2 } })
    },
    goxcx() {
      this.$router.push({ path: '/myxcxset', query: { websiteType: 3 } })
    },
  },
  destroyed() {
    window.onresize = function () {}
  },
  mounted() {},
}
</script>
<style lang="scss">
@import './myweb';
</style>
